import {Injectable} from '@angular/core';
import {AuthenticationService} from "./authentication.service";
import {User} from "../models/user";
import {Role} from "../dip/role";
import {OrganizationTreeSelect} from "../dip/organization-tree-select";

@Injectable({
  providedIn: 'root'
})

export class RoleService {
  private readonly user: User;

  constructor(private authenticationService: AuthenticationService, private organizationTreeSelect: OrganizationTreeSelect) {
    this.user = authenticationService.currentUserValue;
  }

  hasRole(roles: string[]): boolean {
    if (this.user.roles.indexOf(Role.ROLE_SYS) !== -1) {
      return true;
    }

    let companyRoles = [];
    if (this.organizationTreeSelect.company) {
      roles.forEach((r, k) => {
        if (r !== Role.ROLE_DISTRIBUTOR_ADMIN && r !== Role.ROLE_DISTRIBUTOR) {
          companyRoles[k] = `${this.organizationTreeSelect.company.id}_${r}`
        }
      });
    }

    return this.user && this.user.roles.some(role => companyRoles.includes(role));
  }
}
